/**
 * Résultat explicite d'une opération qui peut échouer de façon attendue.
 * On réserve les exceptions aux erreurs inattendues (réseau, bug).
 */
export type Result<TValue, TError> = Success<TValue> | Failure<TError>;

export interface Success<TValue> {
  readonly ok: true;
  readonly value: TValue;
}

export interface Failure<TError> {
  readonly ok: false;
  readonly error: TError;
}

export const succeed = <TValue>(value: TValue): Success<TValue> => ({ ok: true, value });

export const fail = <TError>(error: TError): Failure<TError> => ({ ok: false, error });
